<button
 *ngIf="isAvailable; else unavailableCitation"
 class="citation-button"
 [matTooltip]="tooltipText"
 [attr.aria-label]="getAriaLabel()"
 (click)="onClick()"
 type="button">
 [{{ citationNumber }}]
</button>

<ng-template #unavailableCitation>
 <span class="citation-unavailable" [attr.aria-label]="getAriaLabel()">
   [{{ citationNumber }}]
 </span>
</ng-template>
